(function() {
	'use strict';

	angular.module('exportsApp').controller('ExportsController',
			ExportsController);

	ExportsController.$inject = [ '$scope', '$state', '$stateParams',
			'$base64', '$window','CONST_EXPORTS', 'ExportsService','CommonService',
			'$http', '$log', 'Upload', 'AlertService','EVENT',
			'authExpiredInterceptor', '$uibModal','NgTableParams' ];

	function ExportsController($scope, $state, $stateParams, $base64, $window,CONST_EXPORTS, ExportsService,CommonService, $http, $log, Upload,
			AlertService,EVENT, authExpiredInterceptor, $uibModal,NgTableParams) {
		var exportCtr = this;
		var param = $stateParams;
		$scope.loading = false;
		$scope.$on(EVENT.changeOffice, function(event, args) {
			if(event.name = 'CHANGE_OFFICE') {
				$state.go($state.current, {}, {reload: true});
			}
		});
		exportCtr.CONST_EXPORTS = CONST_EXPORTS;
		if($stateParams.paramSearch!=undefined){
			var paramSearch=$base64.decode($stateParams.paramSearch);
		}
		var paramStatus=exportCtr.CONST_EXPORTS.VALUE_NULL;
		var paramCreatedDate=exportCtr.CONST_EXPORTS.VALUE_NULL;
		var paramStockTransfer=exportCtr.CONST_EXPORTS.VALUE_NULL;
		var paramStockRequest=exportCtr.CONST_EXPORTS.VALUE_NULL;
		var paramStockTransferCode=exportCtr.CONST_EXPORTS.VALUE_NULL;
		if(paramSearch!=undefined){
			var splitted = paramSearch.split(exportCtr.CONST_EXPORTS.SIGN_SEMICOLON);
			for(var i=0;i<splitted.length;i++){
				var paramSpit=splitted[i].split(exportCtr.CONST_EXPORTS.SIGN_COLON);
				if(paramSpit[0]==exportCtr.CONST_EXPORTS.PARAM_STATUS&&paramSpit[1]!=exportCtr.CONST_EXPORTS.VALUE_NULL){
					paramStatus=paramSpit[1];
				}
				if(paramSpit[0]==exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE&&paramSpit[1]!=exportCtr.CONST_EXPORTS.VALUE_NULL){
					paramStockTransferCode=paramSpit[1];
				}
				if(paramSpit[0]==exportCtr.CONST_EXPORTS.PARAM_CREATE_DATE&&paramSpit[1]!=exportCtr.CONST_EXPORTS.VALUE_NULL){
					paramCreatedDate=new Date(paramSpit[1]);
				}
				if(paramSpit[0]==exportCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST&&paramSpit[1]!=exportCtr.CONST_EXPORTS.VALUE_NULL){
					paramStockRequest=paramSpit[1];
				}
				if(paramSpit[0]==exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER&&paramSpit[1]!=exportCtr.CONST_EXPORTS.VALUE_NULL){
					paramStockTransfer=paramSpit[1];
				}
			}
		}
		exportCtr.dateOptions = {
			maxDate : new Date()
		};
		exportCtr.getItemArray = function(array, code) {
			if (code == null || code == undefined || code == '') {
				return "";
			}		
			try {
				var obj = array.filter(function(val) {
					return val.statusCode === code;
				});
				return obj[0].statusName;
			} catch (e) {

			}			
		};
		exportCtr.getItemStockArray = function(array, stockId) {
			if (stockId == null || stockId == undefined || stockId == '') {
				return "";
			}		
			try {
				var obj = array.filter(function(val) {
					return val.stockId === stockId;
				});
				return obj[0].stockName;
			} catch (e) {

			}			
		};
		exportCtr.getItemStockIdArray = function(array, stockId) {
			if (stockId == null || stockId == undefined || stockId == '') {
				return "";
			}		
			try {
				var obj = array.filter(function(val) {
					return val.stockId === stockId;
				});
				return obj[0].stockId;
			} catch (e) {

			}			
		};
		exportCtr.printTemplate = function() {
			ExportsService.query({uri : 'getStockApprovedByOfficeCode'}).$promise.then(function(result){
    				if(result[0].flagError==0){
    					ExportsService.download({uri:'template-upload'});
    				}else{
    					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
    				}
      });
    }
		exportCtr.download=function() {
			//danh cho ie
			if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
				if(exportCtr.attachment.content!=undefined){
					var byteCharacters = atob(exportCtr.attachment.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
					    byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob=new Blob([byteArray], { type: exportCtr.attachment.type+';charset=utf-8' });
					window.navigator.msSaveBlob(blob, exportCtr.attachment.name);
				}else{
					 var blob=new Blob([exportCtr.attachment], { type: exportCtr.attachment.type+';charset=utf-8' });
					 window.navigator.msSaveBlob(blob, exportCtr.attachment.name);
				 }
			}else{
				//truong hop file da luu duoi database
				if(exportCtr.attachment.content!=undefined){
					var byteCharacters = atob(exportCtr.attachment.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
					    byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob=new Blob([byteArray], { type: exportCtr.attachment.type+';charset=utf-8' });
				    var url = $window.URL || $window.webkitURL;
				    var aTag = document.createElement("a");
		    		aTag.style = "display: none";
		    		aTag.href = url.createObjectURL(blob);
		    		aTag.download = exportCtr.attachment.name;
		    		aTag.click();
				}else{
					//truong hop file luu tam tren man hinh
					var blob=new Blob([exportCtr.attachment], { type: exportCtr.attachment.type+';charset=utf-8' });
					var url = $window.URL || $window.webkitURL;
				    var aTag = document.createElement("a");
		    		aTag.style = "display: none";
		    		aTag.href = url.createObjectURL(blob);
		    		aTag.download = exportCtr.attachment.name;
		    		aTag.click();
				}
			}
		}
		exportCtr.find = function() {
			if (param.typeMenu == exportCtr.CONST_EXPORTS.CREATE_STATUS_VIEW) {
				exportCtr.tableParams = new NgTableParams({
					page: 1, // show first page
					count : 5,
					sorting: { 'stock_transfer_code': 'asc' } 
				// count per page
				}, {
//					filterDelay : 300,
//					total: transferAll[0].totalCount,
					total: 0,
					defaultSort: 'asc',
					getData: function(params) {
			    		var param = {};
			    		exportCtr.transferRequestDTO.page = params.page();
			    		exportCtr.transferRequestDTO.size = params.count();
			    		exportCtr.transferRequestDTO.sorting = JSON.stringify(params.sorting());
			    		return ExportsService.postPage({
							uri : 'getAllRequest'
						},exportCtr.transferRequestDTO).$promise.then(function(result) {
			    			params.total(result.totalElements);
			    			exportCtr.lengthSearch = result.totalElements;
							return result.content;;
						});
					 }
				});
			}else{
				exportCtr.tableParams = new NgTableParams({
					page: 1, // show first page
					count : 5,
					sorting: { 'stock_transfer_code': 'asc' } 
				// count per page
				}, {
//					filterDelay : 300,
//					total: transferAll[0].totalCount,
					total: 0,
					defaultSort: 'asc',
					getData: function(params) {
			    		var param = {};
			    		exportCtr.transferRequestDTO.page = params.page();
			    		exportCtr.transferRequestDTO.size = params.count();
			    		exportCtr.transferRequestDTO.sorting = JSON.stringify(params.sorting());
			    		return ExportsService.postPage({
							uri : 'getAllRequestApprove'
						},exportCtr.transferRequestDTO).$promise.then(function(result) {
			    			params.total(result.totalElements);
			    			exportCtr.lengthSearch = result.totalElements;
							return result.content;;
						});
					 }
				});
			}
		}
		
		if (param.typeMenu == exportCtr.CONST_EXPORTS.CREATE_STATUS_VIEW) {
			ExportsService.query({
				uri : 'getAllStockBranch'}).$promise.then(function(result){
				//$scope.$parent.appCtrl.account.currentOffice.officeCode
				exportCtr.transferRequestDTO={stockRequestLst:result,createdDate:paramCreatedDate
							,status:paramStatus,stockTransferId:exportCtr.getItemStockIdArray(result,parseInt(paramStockTransfer)),
							stockRequestId:exportCtr.getItemStockIdArray(result,parseInt(paramStockRequest)),stockTransferCode:paramStockTransferCode
							,page:1,size:5,sorting:'stock_transfer_code: "asc"'};
				exportCtr.createFlag = true;
				exportCtr.approveFlag = false;
				ExportsService.query({
					uri : 'getAllStatus'
				}, function(result) {
					exportCtr.statusLst = result;
					exportCtr.tableParams = new NgTableParams({
						page: 1, // show first page
						count : 5,
						sorting: { 'stock_transfer_code': 'asc' } 
					// count per page
					}, {
//						filterDelay : 300,
//						total: transferAll[0].totalCount,
						total: 0,
						defaultSort: 'asc',
						getData: function(params) {
				    		var param = {};
				    		exportCtr.transferRequestDTO.page = params.page();
				    		exportCtr.transferRequestDTO.size = params.count();
				    		exportCtr.transferRequestDTO.sorting = JSON.stringify(params.sorting());
				    		return ExportsService.postPage({
								uri : 'getAllRequest'
							},exportCtr.transferRequestDTO).$promise.then(function(result) {
				    			params.total(result.totalElements);
				    			exportCtr.lengthSearch = result.totalElements;
								return result.content;;
							});
						 }
					});
				});
			});
		} else {
			ExportsService.query({
				uri : 'getAllStockBranch'
			}).$promise.then(function(result){
				exportCtr.transferRequestDTO={stockRequestLst:result,createdDate:paramCreatedDate
						,status:paramStatus,stockTransferId:exportCtr.getItemStockIdArray(result,parseInt(paramStockTransfer)),stockTransferLst:result,
						stockRequestId:exportCtr.getItemStockIdArray(result,parseInt(paramStockRequest)),stockTransferCode:paramStockTransferCode
						,page:1,size:5,sorting:'stock_transfer_code: "asc"'};
				exportCtr.createFlag = false;
				exportCtr.approveFlag = true;
				ExportsService.query({
						uri : 'getAllStatusApprove'
					}, function(result) {
						exportCtr.statusLst = result;
						exportCtr.tableParams = new NgTableParams({
							page: 1, // show first page
							count : 5,
							sorting: { 'stock_transfer_code': 'asc' } 
						// count per page
						}, {
//							filterDelay : 300,
//							total: transferAll[0].totalCount,
							total: 0,
							defaultSort: 'asc',
							getData: function(params) {   
					    		var param = {};
					    		exportCtr.transferRequestDTO.page = params.page();
					    		exportCtr.transferRequestDTO.size = params.count();
					    		exportCtr.transferRequestDTO.sorting = JSON.stringify(params.sorting());
					    		return ExportsService.postPage({
									uri : 'getAllRequestApprove'
								},exportCtr.transferRequestDTO).$promise.then(function(result) {
					    			params.total(result.totalElements);
					    			exportCtr.lengthSearch = result.totalElements;
									return result.content;;
								});
					        }
				       });
			    });
			});
		}
		exportCtr.viewInfo = function(idx) {
			var typeProcess = exportCtr.CONST_EXPORTS.VIEW_STATUS_CODE;
			paramSearch=exportCtr.CONST_EXPORTS.VALUE_NULL;
			if(exportCtr.transferRequestDTO.stockRequestId!=undefined){
				if(paramSearch!=''){
					paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockRequestId;
				}else{
					paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockRequestId;
				}
			}
			if(exportCtr.transferRequestDTO.stockTransferId!=undefined){
				if(paramSearch!=''){
					paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockTransferId;
				}else{
					paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockTransferId;
				}			
			}
			if(exportCtr.transferRequestDTO.createdDate!='Invalid Date'){
				if(paramSearch!=''){
					paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_CREATE_DATE+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.createdDate;
				}else{
					paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_CREATE_DATE+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.createdDate;
				}
			}
			if(exportCtr.transferRequestDTO.status!=undefined){
				if(paramSearch!=''){
					paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_STATUS+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.status;
				}else{
					paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_STATUS+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.status;
				}
			}
			if(exportCtr.transferRequestDTO.stockTransferCode!=undefined){
				if(paramSearch!=''){
					paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockTransferCode;
				}else{
					paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockTransferCode;
				}
			}
			window.location.href = GLOBAL_URL
					+ exportCtr.CONST_EXPORTS.URL_EXPORTS
					+ '/'
					+ exportCtr.CONST_EXPORTS.CREATE_STATUS_VIEW
					+ '/'
					+ $base64.encode(typeProcess)
					+ '/'
					+ $base64.encode(paramSearch)
					+ '/'
					+ $base64.encode(exportCtr.tableParams.data[idx].stockTransferCode);			
		}
		exportCtr.editInfo = function(idx) {
			ExportsService.query({uri : 'getStockApprovedByOfficeCode'}).$promise.then(function(result){
				if(result[0].flagError==0){
					var typeProcess = exportCtr.CONST_EXPORTS.MODIFY_STATUS_CODE;
					paramSearch=exportCtr.CONST_EXPORTS.VALUE_NULL;
					if(exportCtr.transferRequestDTO.stockRequestId!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockRequestId;
						}else{
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockRequestId;
						}
					}
					if(exportCtr.transferRequestDTO.stockTransferId!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockTransferId;
						}else{
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockTransferId;
						}			
					}
					if(exportCtr.transferRequestDTO.createdDate!='Invalid Date'){
						if(paramSearch!=''){
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_CREATE_DATE+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.createdDate;
						}else{
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_CREATE_DATE+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.createdDate;
						}
					}
					if(exportCtr.transferRequestDTO.status!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_STATUS+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.status;
						}else{
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_STATUS+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.status;
						}
					}
					if(exportCtr.transferRequestDTO.stockTransferCode!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockTransferCode;
						}else{
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockTransferCode;
						}
					}
					window.location.href = GLOBAL_URL
							+ exportCtr.CONST_EXPORTS.URL_EXPORTS
							+ '/'
							+ exportCtr.CONST_EXPORTS.APPROVE_STATUS_VIEW
							+ '/'
							+ $base64.encode(typeProcess)
							+ '/'
							+ $base64.encode(paramSearch)
							+ '/'
							+ $base64.encode(exportCtr.tableParams.data[idx].stockTransferCode);
				}else{
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
			});

		}
		exportCtr.approveInfo = function(idx) {
			ExportsService.query({uri : 'getStockApprovedByOfficeCode'}).$promise.then(function(result){
				if(result[0].flagError==0){
					var typeProcess = exportCtr.CONST_EXPORTS.APPROVE_STATUS_CODE;
					paramSearch=exportCtr.CONST_EXPORTS.VALUE_NULL;
					if(exportCtr.transferRequestDTO.stockRequestId!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockRequestId;
						}else{
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockRequestId;
						}
					}
					if(exportCtr.transferRequestDTO.stockTransferId!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockTransferId;
						}else{
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockTransferId;
						}			
					}
					if(exportCtr.transferRequestDTO.createdDate!='Invalid Date'){
						if(paramSearch!=''){
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_CREATE_DATE+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.createdDate;
						}else{
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_CREATE_DATE+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.createdDate;
						}
					}
					if(exportCtr.transferRequestDTO.status!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_STATUS+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.status;
						}else{
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_STATUS+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.status;
						}
					}
					if(exportCtr.transferRequestDTO.stockTransferCode!=undefined){
						if(paramSearch!=''){
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockTransferCode;
						}else{
							paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockTransferCode;
						}
					}
					window.location.href = GLOBAL_URL
							+ exportCtr.CONST_EXPORTS.URL_EXPORTS
							+ '/'
							+ exportCtr.CONST_EXPORTS.APPROVE_STATUS_VIEW
							+ '/'
							+ $base64.encode(typeProcess)
							+ '/'
							+ $base64.encode(paramSearch)
							+ '/'
							+ $base64.encode(exportCtr.tableParams.data[idx].stockTransferCode);
				}else{
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
			});

		}
		exportCtr.openCreate = function() {
			ExportsService.query({uri : 'getStockByOfficeCode'}).$promise.then(function(result){
				if(result[0].flagError==0){
//					var tempDate=new Date();
//					var toDate=new Date(tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate());
//					if(new Date(result[0].area.fromDate)>toDate||new Date(result[0].area.toDate)<toDate){
//						$scope.addAlert('Hết thời gian đặt hàng. Vui lòng liên hệ OP admin','error');
//					}else{
						var typeProcess = exportCtr.CONST_EXPORTS.CREATE_STATUS_CODE;
						paramSearch=exportCtr.CONST_EXPORTS.VALUE_NULL;
						if(exportCtr.transferRequestDTO.stockRequestId!=undefined){
							if(paramSearch!=''){
								paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockRequestId;
							}else{
								paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockRequestId;
							}
						}
						if(exportCtr.transferRequestDTO.stockTransferId!=undefined){
							if(paramSearch!=''){
								paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockTransferId;
							}else{
								paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockTransferId;
							}			
						}
						if(exportCtr.transferRequestDTO.createdDate!='Invalid Date'){
							if(paramSearch!=''){
								paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_CREATE_DATE+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.createdDate;
							}else{
								paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_CREATE_DATE+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.createdDate;
							}
						}
						if(exportCtr.transferRequestDTO.status!=undefined){
							if(paramSearch!=''){
								paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_STATUS+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.status;
							}else{
								paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_STATUS+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.status;
							}
						}
						if(exportCtr.transferRequestDTO.stockTransferCode!=undefined){
							if(paramSearch!=''){
								paramSearch=paramSearch+exportCtr.CONST_EXPORTS.SIGN_SEMICOLON+exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockTransferCode;
							}else{
								paramSearch=paramSearch+exportCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+exportCtr.CONST_EXPORTS.SIGN_COLON+exportCtr.transferRequestDTO.stockTransferCode;
							}
						}
						window.location.href = GLOBAL_URL
								+ exportCtr.CONST_EXPORTS.URL_EXPORTS
								+ '/'
								+ exportCtr.CONST_EXPORTS.CREATE_STATUS_VIEW 
								+ '/'
								+ $base64.encode(typeProcess)
								+ '/'
								+ $base64.encode(paramSearch);
//					}
				}else{
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
			});
		};
		exportCtr.uploadFile=function(){
			ExportsService.query({uri : 'getStockApprovedByOfficeCode'}).$promise.then(function(result){
				if(result[0].flagError==0){
					var data = [];
					if (exportCtr.attachment) {
						data['file'] = exportCtr.attachment;
						Upload.upload(
								{
									url : GLOBAL_URL
											+ 'api/e-stock/exports/doUploadFile?_csrf='
											+ authExpiredInterceptor.getCSRF(),
									data : data
								}).then(
								function(resp) {
									$scope.loading=false;
									$scope.addAlert('Upload thành công','success');
							    ExportsService.download({uri:'result-upload'},resp.data);
								},
								function(evt) {
									var progressPercentage = parseInt(100.0
											* evt.loaded / evt.total);
									$log.debug('progress: ' + progressPercentage + '% '
											+ evt.config.data.file.name);
								});
					}
				}else{
					$scope.loading = false;
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
			});
		}
		exportCtr.exportReport = function() {
			$scope.loading=true;
			ExportsService.download({uri:'export-report'}, exportCtr.transferRequestDTO,function(result) {
	        		$scope.loading=false;
	        }, function(error){
					$scope.loading=false;
	    	});	
        }
		exportCtr.dod = new Date();
		exportCtr.openDod = function() {
			exportCtr.popupDod.opened = true;
		};

		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
				'shortDate' ];
		$scope.format = $scope.formats[2];
		$scope.altInputFormats = [ 'M!/d!/yyyy' ];
		exportCtr.popupDod = {
			opened : false
		};

	}
})();
